import React, { useEffect, useState } from "react";
import XLSX from 'xlsx';
import moment from 'moment-jalaali';
import { Form, Select } from 'antd';
// import DatePicker from 'react-datepicker2';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ValidatorHelper from "../helpers/ValidatorHelper";
import { useNavigate } from "react-router-dom";
import UserServices from "../../services/UserServices";
import { DownOutlined, LoadingOutlined } from '@ant-design/icons'
import { usePersistedStore } from "../../store/persisted-store";
import { useReportsStore } from "../../store/slices/createReportsSlice";

export default function UserFilter(params) {
    const { business, GET_FILTER_USERS, users: usersState } = usePersistedStore();
    const [fromDate, setFromDate] = useState(null);
        const [toDate, setToDate] = useState(null);
    const reports = useReportsStore()
    const navigate = useNavigate();
    const users = usersState.filterUsers;
    const usersLoading = usersState.loading;
    const data = reports.purchases.data;
    const loading = reports.purchases.loading;
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;

    useEffect(() => {
        if (!token)
            navigate('/dashboard');

        UserServices.getFilterUsers().then((res) => {
            GET_FILTER_USERS(res.data)
        }).catch((error) => {


        })

    }, [navigate, token])

    function convertToMoment(date) {
        return moment(date?.toDate()).format("YYYY-MM-DD");
    }
    

    function onFinish(values) {

        const params = {
            fromDate: convertToMoment(fromDate), //values.fromDate && moment(values.fromDate).format(),
            toDate: convertToMoment(toDate), //values.toDate && moment(values.toDate).format(),
            UserId: users.filter(user => user.Title === values.UserName)[0].Id
        }
        reports.getUserPurchases({ param: params })
    }

    function downloadxlsx() {
        if (!data) return
        let xlsxData = data.map(d => [
            d.BranchName,
            d.BusinessWageAmount,
            d.BusinessWagePercent,
            d.CompanyName,
            moment(d.IssuanceDate).format('jYYYY/jMM/jDD'),
            d.Payment,
            d.PersonName,
            d.SummarizeAmount,
            d.RequestId,
            d.TrackingCode,
            d.VoucherAmount
        ])
        xlsxData.unshift(['نام رشته', 'مبلغ کارمزد', 'درصد کارمزد', 'نام شرکت بیمه', 'تاریخ صدور', 'مبلغ پرداختی',
            'نام بیمه گزار', 'مبلغ کل', 'شناسه یکتا', 'کد پیگیری', 'تخفیف'])
        const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
        const new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
        XLSX.writeFile(new_workbook, "bimeh[dot]com.xlsx")
    }

    return (
        <Form
            initialValues={{
                user: "all",
                fromDate: params.fromDate && moment(params.fromDate).subtract(1, 'months'),
                toDate: params.toDate && moment(params.toDate)
            }}
            layout="inline" onFinish={onFinish}>

            <Form.Item
                rules={ValidatorHelper.required('کاربر')}
                name='UserName'
                label="کاربران:">

                <Select
                    suffixIcon={usersLoading ? <LoadingOutlined /> : <DownOutlined />}
                    showSearch
                    loading={usersLoading}
                    disabled={!users.length || usersLoading}
                    style={{ minWidth: 190 }}>
                    {users && users.map((name, index) => {
                        return <Select.Option key={index} value={name.Title}>{name.Title}</Select.Option>
                    })}
                </Select>
            </Form.Item>
            <Form.Item
                style={{ width: "220px" }}
                name='fromDate'
                label='از تاریخ'>
                <DatePicker
                    value={fromDate}
                    onChange={setFromDate}
                    calendar={persian}
                    locale={persian_fa}
                    format="YYYY/MM/DD"
                    inputClass="datepicker-input"
                    calendarPosition="bottom-right"
                    portal
                    zIndex={1070}
                />
            </Form.Item>
            <Form.Item
                style={{ width: "220px" }}
                name='toDate'
                label='تا تاریخ'>
                <DatePicker
                    value={toDate}
                    onChange={setToDate}
                    calendar={persian}
                    locale={persian_fa}
                    format="YYYY/MM/DD"
                    inputClass="datepicker-input"
                    calendarPosition="bottom-right"
                    portal
                    zIndex={1070}
                />
            </Form.Item>
            <Form.Item label=" " colon={false}>
                <button type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit">
                    <i className={`${loading ? "bx bx-loader bx-spin" : "fas fa-search"} "font-size-14 align-middle mr-2 ml-3"`}></i>شبسیب جستجو
                </button>
                <button type="primary" className="btn btn-success bt-sm waves-effect waves-light" htmltype="submit"
                    onClick={downloadxlsx} style={{ marginRight: "10px" }}>
                    <i className="far fa-file-excel font-size-14 align-middle mr-2"></i> دریافت اکسل
                </button>
            </Form.Item>
        </Form>
    )
}